<template>
    <div class="products" id="products">
        <div class="bannerBox">
            <img class="bannerImg" v-if="inwidth > 768" :src="banner" alt="">
            <img class="bannerImg" v-else :src="phone_pic" alt="">
        </div>
        <div class="overAllBox products-Box">
            <div class="products-Title">Products</div>
            <div class="products-NavBox">
                <div  v-for="(item,index) in navlist" :key="index">
                    <div class="products-NavBox-li pr" v-if="item.cate.length > 0" style="padding-bottom:0"
                        :class="cate_id == values[index] ? 'products-NavBox-li-active' : ''">
                        <div class="navMask" @click="navSwitch(values[index], index)"></div>
                        <el-select v-if="item" v-model="values[index]" :popper-append-to-body="false" placeholder="请选择"
                            @change="selectSwitch1($event, values[index],index)">
                            <el-option v-for="items in item.cate" :key="items.id" :label="items.class_name"
                                :value="items.id"></el-option>
                        </el-select>
                    </div>
                    <div class="products-NavBox-li" v-else :class="cate_id == item.id ? 'products-NavBox-li-active' : ''"
                        @click="navSwitch(item.id, index)">{{ item.class_name }}</div>
                </div>
                <!-- <div v-if="navlist[0]">
                    <div class="products-NavBox-li pr" v-if="navlist[0].cate.length > 0" style="padding-bottom:0"
                        :class="cate_id == value0 ? 'products-NavBox-li-active' : ''">
                        <div class="navMask" @click="navSwitch(value0, 0)"></div>
                        <el-select v-if="navlist[0]" v-model="value0" :popper-append-to-body="false" placeholder="请选择"
                            @change="selectSwitch1($event, value0)">
                            <el-option v-for="item in navlist[0].cate" :key="item.id" :label="item.class_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="products-NavBox-li" v-else :class="cate_id == navlist[0].id ? 'products-NavBox-li-active' : ''"
                        @click="navSwitch(navlist[0].id, 0)">{{ navlist[0].class_name }}</div>
                </div> -->
                <!-- <div v-if="navlist[1]">
                    <div class="products-NavBox-li pr" v-if="navlist[1].cate.length > 0" style="padding-bottom:0"
                        :class="cate_id == value1 ? 'products-NavBox-li-active' : ''">
                        <div class="navMask" @click="navSwitch(value1, 1)"></div>
                        <el-select v-if="navlist[1]" v-model="value1" :popper-append-to-body="false" placeholder="请选择"
                            @change="selectSwitch2($event, value1)">
                            <el-option v-for="item in navlist[1].cate" :key="item.id" :label="item.class_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="products-NavBox-li" v-else :class="cate_id == navlist[1].id ? 'products-NavBox-li-active' : ''"
                        @click="navSwitch(navlist[1].id, 1)">{{ navlist[1].class_name }}</div>
                </div>

                <div v-if="navlist[2]">
                    <div class="products-NavBox-li pr" v-if="navlist[2].cate.length > 0" style="padding-bottom:0"
                        :class="cate_id == value2 ? 'products-NavBox-li-active' : ''">
                        <div class="navMask" @click="navSwitch(value2, 2)"></div>
                        <el-select v-if="navlist[2]" v-model="value2" :popper-append-to-body="false" placeholder="请选择"
                            @change="selectSwitch3($event, value2)">
                            <el-option v-for="item in navlist[2].cate" :key="item.id" :label="item.class_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="products-NavBox-li" v-else :class="cate_id == navlist[2].id ? 'products-NavBox-li-active' : ''"
                        @click="navSwitch(navlist[2].id, 2)">{{ navlist[2].class_name }}</div>
                </div>

                <div v-if="navlist[3]">
                    <div class="products-NavBox-li pr" v-if="navlist[3].cate.length > 0" style="padding-bottom:0"
                        :class="cate_id == value3 ? 'products-NavBox-li-active' : ''">
                        <div class="navMask" @click="navSwitch(value3, 3)"></div>
                        <el-select v-if="navlist[3]" v-model="value3" :popper-append-to-body="false" placeholder="请选择"
                            @change="selectSwitch4($event, value3)">
                            <el-option v-for="item in navlist[3].cate" :key="item.id" :label="item.class_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="products-NavBox-li" v-else :class="cate_id == navlist[3].id ? 'products-NavBox-li-active' : ''"
                        @click="navSwitch(navlist[3].id, 3)">{{ navlist[3].class_name }}</div>
                </div> -->
            </div>

            <div class="products-list">
                <div class="products-li" v-for="item in list" :key="item.id" @click="toproducts_xq(item.id)">
                    <div class="products-li-img">
                        <img class=" products-li-imgCe" :src="item.pic" alt="">
                    </div>
                    <div class="products-li-text">{{ item.title }}</div>
                </div>
            </div>
            <div class="tips" v-if="myshow"></div>
            <el-pagination v-if="mobshow == false" background layout="prev,pager,next" :pager-count='pagercount'
                :hide-on-single-page="pagehide" :page-size="list_row" :current-page.sync='page' :total="totalCount"
                @current-change='productList_page'></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: "products",
    components: {

    },
    data() {
        return {
            cate_id: 0,
            current: 0,
            values:['','','',''],
            value0: '',
            value1: '',
            value2: '',
            value3: '',
            list: '',
            list_row: 16,
            page: 1,
            totalCount: 0,
            name: '',
            pagehide: true,
            pagercount: 5,
            banner: '',
            keyword: '',
            navlist: {},
            list: [],
            mobshow: false,
            myshow: false,
            mystate: false,
            inwidth: window.innerWidth,
            phone_pic: '',
        };
    },


    created() {
        this.keyword = this.$route.query.keyword
        if (this.$route.query.cate_id) {
            this.cate_id = this.$route.query.cate_id
        }
        if (this.$route.query.page) {
            this.page = Number(this.$route.query.page)
        } else {
            this.page = 1
        }
        let inwidth = window.innerWidth
        if (inwidth <= 750) {
            this.mobshow = true
        }
        this.getBanner();
        this.productCate();
        this.productList(this.page);

    },
    mounted() {
        let inwidth = window.innerWidth
        if (inwidth <= 320) {
            this.pagercount = 3
        }

        if (this.mobshow) {
            window.addEventListener('scroll', this.onScroll)
        }
        window.addEventListener('popstate', this.popstate, false);

    },
    methods: {

        productList_page(currentPage) {
            //  
            this.$router.push({ path: '/products', query: { cate_id: this.cate_id, page: currentPage } })
            //   window.location.reload();
            this.productList(currentPage)

        },
        //产品分类接口
        productCate(page) {
            var that = this;
            let data = {};
            that.$api.productCate(data).then(res => {
                if (res.status == 1) {
                    that.navlist = res.data.list;
                    that.navlist.forEach((element,index) => {
                        that.values[index]=element.id ;
                        if(element.cate.length>0){
                            element.cate.unshift({ class_name: element.class_name, id: element.id})
                            
                        }
                    });
                    that.navlist.forEach((element,index) => {
                            element.cate.forEach((item,indexs)=>{
                                
                                if(item.id==that.cate_id){
                                    that.values[index]=item.id;
                                }
                            })
                    });

                } else {
                    that.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
        },
        //banner
        getBanner() {
            var that = this;
            let data = {
                cate_id: that.cate_id,
                page: 1,
                list_row: that.list_row,
                keyword: that.keyword
            };
            that.$api.productList(data).then(res => {
                if (res.status == 1) {
                    that.banner = res.data.banner;
                    that.phone_pic = res.data.phone_pic;
                } else {
                    that.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });

        },
        //产品列表接口
        productList(page) {
            var that = this;
            let data = {
                cate_id: that.cate_id,
                page: page,
                list_row: that.list_row,
                keyword: that.keyword
            };
            if (that.mobshow) {
                let mylist = that.list
                that.$api.productList(data).then(res => {
                    if (res.status == 1) {
                        mylist = mylist.concat(res.data.list)
                        that.list = mylist;
                        that.totalCount = res.data.pageInfo.totalCount
                        that.myshow = false
                        that.page = page
                        that.mystate = true
                    } else {
                        that.$message({
                            message: res.msg,
                            type: "warning"
                        });
                    }
                });
            } else {
                that.$api.productList(data).then(res => {
                    if (res.status == 1) {
                        that.list = res.data.list;
                        that.totalCount = res.data.pageInfo.totalCount
                    } else {
                        that.$message({
                            message: res.msg,
                            type: "warning"
                        });
                    }
                });
            }
        },
        selectSwitch1(e, id,index) {
            let banner = ''
            this.cate_id = id;
            this.values[index] = id;
            this.list = [];
            let cate = this.navlist[index].cate
            this.$router.push({ path: '/products', query: { cate_id: id, page: 1 } })
            // location.reload(); 
            this.page = 1
            this.productList(this.page);
        },
        selectSwitch2(e, id) {
            let banner = ''
            this.cate_id = id;
            this.values[1] = id;
            this.list = [];
            let cate = this.navlist[1].cate

            this.$router.push({ path: '/products', query: { cate_id: id, page: 1 } })
            // location.reload();
            this.page = 1
            this.productList(this.page);
        },
        selectSwitch3(e, id) {
            let banner = ''
            this.cate_id = id;
            this.values[2] = id;
            this.list = [];
            let cate = this.navlist[2].cate

            this.$router.push({ path: '/products', query: { cate_id: id, page: 1 } })
            // location.reload();
            this.page = 1
            this.productList(this.page);
        },
        selectSwitch4(e, id) {
            let banner = ''
            this.cate_id = id;
            this.values[3] = id;
            this.list = [];
            let cate = this.navlist[3].cate

            this.$router.push({ path: '/products', query: { cate_id: id, page: 1 } })
            // location.reload();
            this.page = 1
            this.productList(this.page);
        },
        navSwitch(id, is) {
            let banner = ''
            this.cate_id = id + ''
            this.list = [];
            let cate = this.navlist[is].cate

            this.$router.push({ path: '/products', query: { cate_id: id, page: 1 } })
            // location.reload();
            this.page = 1
            this.productList(this.page);
        },


        toproducts_xq(id) {
            this.$router.push({ path: '/products_xq', query: { id: id } })
        },




        //滚动触底加载
        onScroll() {
            var that = this
            if (that.mystate) {
                if (that.getScrollHeight() <= that.getWindowHeight() + that.getDocumentTop() + $('.footer').height()) {
                    that.mystate = false
                    if (that.totalCount > that.list.length) {
                        let page = that.page + 1
                        that.productList(page) //请求接口的函数
                        that.myshow = false
                    } else {
                        that.myshow = true
                    }
                }
            }
        },
        //文档高度
        getDocumentTop() {
            var scrollTop = 0,
                bodyScrollTop = 0,
                documentScrollTop = 0;
            if (document.body) {
                bodyScrollTop = document.body.scrollTop;
            }
            if (document.documentElement) {
                documentScrollTop = document.documentElement.scrollTop;
            }
            scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
            return scrollTop;
        },
        //可视窗口高度
        getWindowHeight() {
            var windowHeight = 0;
            if (document.compatMode == "CSS1Compat") {
                windowHeight = document.documentElement.clientHeight;
            } else {
                windowHeight = document.body.clientHeight;
            }
            return windowHeight;
        },
        //滚动条滚动高度
        getScrollHeight() {
            var scrollHeight = 0,
                bodyScrollHeight = 0,
                documentScrollHeight = 0;
            if (document.body) {
                bodyScrollHeight = document.body.scrollHeight;
            }
            if (document.documentElement) {
                documentScrollHeight = document.documentElement.scrollHeight;
            }
            scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
            return scrollHeight;
        },
        popstate() {

            if (this.$route.query.cate_id) {
                this.cate_id = this.$route.query.cate_id
            } else {
                this.cate_id = ''
            }
            this.productList(1);
            // location.reload();
        }


    },
    beforeDestroy() {//清除监听
        window.removeEventListener('scroll', this.onScroll)
    },
    destroyed() { // 销毁vm组件
        // 避免堆栈溢出，多次创建、多次触发
        window.removeEventListener('popstate', this.popstate, false);
    },


};
</script>
<style  >
.bannerBox {
    width: 100%;
    /* height: 50rem; */
}

.bannerImg {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
}

.products-Box {
    padding-top: 5rem;
    padding-bottom: 4rem;
    text-align: center;
}

.products-Title {
    font-size: 3.6rem;
    margin-bottom: 2.8rem;
    font-weight: bold;
    letter-spacing: 0.2rem;
    color: #4c4c4c;
}

.products-NavBox {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    border-bottom: 0.1rem solid #e6e6e6;
    color: #999999;
    font-size: 1.6rem;
    margin-bottom: 4rem;
}

.products-NavBox-li {
    padding-bottom: 1rem;
    border-bottom: 0.3rem solid rgba(0, 0, 0, 0);
    cursor: pointer;
    color: #222222;
}

.products-NavBox-li-active {
    color: #333333;
    border-bottom: 0.3rem solid #000000;
    font-weight: bold;
}

.products-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-right: -2.6rem;
}

.products-li {
    width: 27.8rem;
    /* border: 0.1rem solid #e0e0e0; */
    margin-bottom: 3rem;
    margin-right: 2.6rem;
    cursor: pointer;

}

.products-li-img {
    width: 27.8rem;
    height: 22.8rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.products-li-imgCe {
    margin: 4.3rem 1.2rem;
}

.products-li-text {
    width: 27.8rem;
    height: 5rem;
    line-height: 5rem;
    font-size: 1.6rem;
    text-align: center;
    /* background-color: #f5f5f5; */
    color: #333333;
    border-top: #e0e0e0;

}

.products-li:hover {
    transition: all 1s;
    /* border: 0.1rem solid #000000; */
}

.products-li:hover .products-li-img img {
    transition: all 1s;
    transform: scale(1.2);
}

.products-li:hover .products-li-text {
    transition: all 1s;
    /* background-color: #000000; */
    /* color: #ffffff; */
    border-top: #000000;
}

.products .el-pagination {
    margin-top: 2rem;
}

.products .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0c131b;
    color: #ffffff;
}

.products .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    font-size: 1.4rem;
    border-radius: 0;
    color: #868686;
    background-color: #ebebeb;
}

.products .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #868686;
}

.products .el-select__caret:before {
    content: "\e78f";
    font-size: 18px;
}

.products .el-select .el-input__inner:focus {
    border: none;
}

.products .el-input__inner {
    border: none;
}

.products .el-input--suffix,
.el-select,
.el-input,
.is-focus,
.el-input__inner,
.el-select .el-input.is-focus .el-input__inner {
    outline: none;
    border: none;
    width: 16.5rem;
    color: #222222;
    font-size: 1.6rem;
}

#products .el-select-dropdown__item.selected {
    color: #333333;
}

.products-NavBox-li-active .el-input__inner {
    color: #333333;
}

.navMask {
    position: absolute;
    width: 80%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index: 999;
    color: #222222;
}

.tips {
    width: 100%;
    text-align: center;
    padding: 2rem 0 0;
    font-size: 1.4rem;
    color: #4c4c4c;
}

/*当浏览器尺寸768px时候的代码：*/
@media screen and (min-width:767px) and (max-width: 1024px) {
    .bannerBox {
        height: auto;
    }

    .products-li {
        width: 46%;
    }

    .products-li-img {
        width: 100%;
        height: 28.8rem;
    }

    .products-li-text {
        width: 100%;
    }

    .products .el-input--suffix,
    .el-select,
    .el-input,
    .is-focus,
    .el-input__inner,
    .el-select .el-input.is-focus .el-input__inner {
        width: 16.5rem;
    }
}


/*当浏览器尺寸小于768px时候的代码：手机端 */
@media screen and (max-width:768px) {
    .bannerImg {
        height: 40rem;
    }
}


/*当浏览器尺寸小于414px时候的代码：手机端 */
@media screen and (max-width:414px) {
    .products-list {
        width: 100%;
        margin-right: 0;
        /* justify-content: center; */
    }

    .products-NavBox {
        flex-wrap: wrap;
    }

    .products-NavBox-li {
        width: 15.5rem;
    }

    .products-NavBox-li:nth-child(3),
    .products-NavBox-li:nth-child(4) {
        margin-top: 2rem;
        text-indent: 1.6rem;
        text-align: left;

    }

    .products-li {
        width: 48%;
        margin-right: 0;
        overflow: hidden;
    }

    .products-li:nth-child(odd) {
        margin-right: 2%;
    }

    .products-li-imgCe {
        width: 100%;
        margin: 0;
    }

    .products-li-img {
        width: 100%;
        /* height: auto; */
        height: 20.8rem;
        overflow: hidden;
    }

    .products-li-text {
        width: 100%;
    }

    .products .el-pagination {
        padding: 0;
        margin: 2rem auto 0;
    }

    .bannerImg {
        height: 40rem;
    }
}</style>
